import AppRouter from './app-router.component'

export default AppRouter
